<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="usersList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
        >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-3">
            <div class="d-flex align-center" v-if="usersList.length > 0">
              <v-icon left>mdi-account-multiple</v-icon>
              <span>{{ totalPlayers }}</span>

              <span class="ml-2">
                {{ $tc("usersPlurals", totalPlayers) }}
              </span>

              <v-progress-circular
                v-if="fetchingPlayers"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>
  
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>
        
        <template v-slot:item.status="{ item }">
          <v-chip small :color="handleStatus(item.status).color">
            {{ handleStatus(item.status).text}}
          </v-chip>
        </template>
  
        <template v-slot:item.birth_date="{ item }">
          {{ $handleDate(item.birth_date).date }}
        </template>
  
        <template v-slot:item.register_date="{ item }">
          {{ $handleDate(item.register_date).date }}
        </template>
  
        <template v-slot:item.last_login="{ item }">
          {{ $handleDate(item.last_login).date }}
        </template>
        <template v-slot:item.schedule="{ item }">
          {{ $handleDate(item.last_login).hour }}
        </template>
  
        <template v-slot:item.affilite_id="{ item }">
          {{ handleNullOrEmptyValues(item.affilite_id) }}
        </template>
  
        <template v-slot:item.affiliate_name="{ item }">
          {{ handleNullOrEmptyValues(item.affiliate_name) }}
        </template>
  
        <template v-slot:item.local_manager_id="{ item }">
          {{ handleNullOrEmptyValues(item.local_manager_id) }}
        </template>
  
        <template v-slot:item.local_manager_name="{ item }">
          {{ handleNullOrEmptyValues(item.local_manager_name) }}
        </template>
      </v-data-table>
      <v-pagination
        v-if="pageCount > 0 && usersList.length > 0"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="pb-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-usuarios",
  data: (vm) => ({
    loading: false,
    fetchingPlayers: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    cachedPage: {},
    search: "",
    totalPlayers: 0,
    headers: [
      {
        text: "ID",
        value: "id",
        align: "no-wrap"
      },
      {
        text: vm.$t("name"),
        value: "name",
        align: "no-wrap"
      },
      {
        text: vm.$t("cpfLabel"),
        value: "document",
        align: "no-wrap"
      },
      {
        text: vm.$t("cellPhone"),
        value: "phone",
        align: "no-wrap"
      },
      {
        text: "Login",
        value: "login",
        align: "no-wrap"
      },
      {
        text: "Email",
        value: "email",
        align: "no-wrap"
      },
      {
        text: vm.$t("birthday"),
        value: "birth_date",
        align: "no-wrap"
      },
      {
        text: "Status",
        value: "status",
        align: "no-wrap"
      },
      {
        text: vm.$t("dtRegistration"),
        value: "register_date",
        align: "no-wrap"
      },
      {
        text: vm.$t("lastLogin"),
        value: "last_login",
        align: "no-wrap"
      },
      {
        text: vm.$t("schedule"),
        value: "schedule",
        align: "no-wrap"
      },
      {
        text: vm.$t("onlineBalance"),
        value: "balance_online",
        align: "no-wrap"
      },
      {
        text: vm.$t("amountOfDeposits"),
        value: "deposit_qty",
        align: "no-wrap"
      },
      {
        text: vm.$t("deposits"),
        value: "deposit_value",
        align: "no-wrap"
      },
      {
        text: vm.$t("affiliateId"),
        value: "affilite_id",
        align: "no-wrap"
      },
      {
        text: vm.$t("affiliate"),
        value: "affiliate_name",
        align: "no-wrap"
      },
      {
        text: vm.$t("localManagerId"),
        value: "local_manager_id",
        align: "no-wrap"
      },
      {
        text: vm.$t("localManagerName"),
        value: "local_manager_name",
        align: "no-wrap"
      },
    ],
    usersList: [],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  watch: {
    rangeDate() {
      this.debouncedFetchTotalPlayersByRange();
    },
    saveFilters(bool) {
      bool && this.playersReport();
    },
    page() {
      this.playersReport();
    },
    totalPlayers(players) {
      if (players == 0) {
        this.usersList = [];
      }
    }
  },

  mounted() {
    this.debouncedFetchTotalPlayersByRange();
  },

  methods: {
    debouncedFetchTotalPlayersByRange() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(()=> {this.fetchTotalPlayersByRange()}, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalPlayersByRange() {
      this.fetchingPlayers = true;
      const body = {
        ...this.rangeDate,
      }
      await this.$axios
        .post(`${this.$prefix()}/players/countTotalPlayersByRange`, this.$formdata(body))
        .then((response) => {
          this.totalPlayers = Number(response.data.dados.total_players);
          this.pageCount = Math.ceil(this.totalPlayers / 100);
          this.fetchingPlayers = false;
        }).catch(() => this.fetchingPlayers = false);
    },

    async playersReport() {
      const currentRangeDate = this.rangeDate
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      }

      if (this.exportDoc) {
        await this.$request.exportDoc(
          `${this.$prefix()}/players/playerReport`,
          body,
          this.exportDoc,
          this.rangeDate
        );
        return
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.usersList = []
      
      if (this.cachedPage[this.page] && currentRangeDate != this.rangeDate) {
        this.usersList = this.cachedPage[this.page]
        this.loading = false;
        return
      }

      const response = await this.$request.post(
        `${this.$prefix()}/players/playerReport`, body
        );
        
        if (!response.dados) {
          this.usersList = [];
          this.loading = false;
          return;
        }
        
        this.usersList = response.dados;
        this.cachedPage[this.page] = this.usersList;
        this.loading = false;
    },

    handleStatus(status) {
      if (status == 1) return { text: this.$t("active"), color: "green"};
      if (status == 0) return { text: this.$t("suspended"), color: "red"};
      if (status == 5) return { text: this.$t("pending"), color: "grey"};
      if (status == 6) return { text: this.$t("blocked"), color: "red"};
      return { text: this.$t("disabled"), color: "grey" };
    },

    handleNullOrEmptyValues(value) {
      if (!value || value == "0") {
        return " ••• ";
      }

      if (value) {
        return value;
      } else {
        return " ••• ";
      }
    }
  }
}
</script>